import { useAsync } from 'react-async-hook';
import { Article } from '../types/Article';
import { wordpress } from '../client';

export const useArticleById = (articleId: number) => {
  const { result: article, loading } = useAsync(() => fetchArticle(articleId), [articleId]);
  return { article, loading };
};

const fetchArticle = (articleId: number): Promise<Article> => wordpress.posts().id(articleId).get();
